export const tryParseJson = (value: string) => isJsonString(value) ? JSON.parse(value) : value;

export const isJsonString = (str: any) => {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
};

export const tryStringifySettingValue = (value: unknown): string | number | boolean | unknown => {
	switch (typeof value) {
		case 'boolean':
		case 'number':
		case 'string':
			return value;
		case 'object':
			return JSON.stringify(value);
		default:
			return value;
	}
};

